import { NodeType } from '@/enums/node-type.enum';

export const DEFAULT_NODE_WIDTH = 460;

export const RESIZABLE_NODE_TYPES = new Set<NodeType>([
  NodeType.String,
  NodeType.PromptV3,
  NodeType.PromptConcat,
  NodeType.CustomModelV2,
  NodeType.Array,
  NodeType.MuxV2,
]);

export interface NodeResizeLimits {
  minHeight: number;
  maxHeight: number;
  autoResizeMaxHeight: number;
}

export interface ResizableDimensions extends NodeResizeLimits {
  defaultHeight: number;
  defaultTextareaHeight: number;
}

export const TEXTAREA_BASE_HEIGHT = 430;

export const getResizableDimensions = (
  chromeHeight: number,
  size: 'large' | 'small' = 'large',
): ResizableDimensions => {
  const textareaHeight = Math.round(size === 'large' ? TEXTAREA_BASE_HEIGHT : (TEXTAREA_BASE_HEIGHT * 2) / 3);
  return {
    defaultHeight: textareaHeight + chromeHeight,
    defaultTextareaHeight: textareaHeight,
    minHeight: Math.round(TEXTAREA_BASE_HEIGHT / 3) + chromeHeight,
    maxHeight: TEXTAREA_BASE_HEIGHT * 3 + chromeHeight,
    autoResizeMaxHeight: Math.round(TEXTAREA_BASE_HEIGHT * 1.2) + chromeHeight,
  };
};

export const DEFAULT_RESIZABLE_DIMENSIONS: ResizableDimensions = getResizableDimensions(70, 'small');

export const LIST_NODE_ITEM_GAP = 6;
const LIST_NODE_ITEM_HEIGHT = 32;
const LIST_NODE_BASE_CHROME = 76;
const LIST_NODE_ADD_BUTTON_HEIGHT = 28;

export const getListNodeResizeLimits = ({
  itemCount,
  hasDelimiterRow,
  hasAddButton,
}: {
  itemCount: number;
  hasDelimiterRow: boolean;
  hasAddButton: boolean;
}): NodeResizeLimits => {
  let chromeHeight = LIST_NODE_BASE_CHROME;
  if (hasDelimiterRow) chromeHeight += LIST_NODE_ITEM_HEIGHT + LIST_NODE_ITEM_GAP;
  if (hasAddButton) chromeHeight += LIST_NODE_ADD_BUTTON_HEIGHT + LIST_NODE_ITEM_GAP;

  const contentMaxHeight =
    itemCount * LIST_NODE_ITEM_HEIGHT + Math.max(0, itemCount - 1) * LIST_NODE_ITEM_GAP + chromeHeight;
  return {
    minHeight: Math.min(Math.round(TEXTAREA_BASE_HEIGHT / 8) + chromeHeight, contentMaxHeight),
    maxHeight: contentMaxHeight,
    autoResizeMaxHeight: contentMaxHeight,
  };
};
